export function formatNumber(value) {
  const number = Number(value || 0);
  return new Intl.NumberFormat().format(number);
}

export function formatHours(value) {
  const number = Number(value || 0);
  return `${number.toLocaleString(undefined, { maximumFractionDigits: 2 })}h`;
}

export function formatPercent(value) {
  const number = Number(value || 0);
  return `${number.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`;
}

export function formatKpiValue(item) {
  if (!item) return '-';
  if (item.format === 'text') return String(item.value ?? '-');
  if (item.format === 'percent') return formatPercent(item.value);
  if (item.format === 'hours') return formatHours(item.value);
  if (item.format === 'hoursPerDay') return `${Number(item.value || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}h/day`;
  return formatNumber(item.value);
}

export function safeDateLabel(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString();
}

export function toTitle(text) {
  return String(text || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
